export default __webpack_public_path__ + "static/media/cloud-uploadv2.4b3288af.svg";